export default __webpack_public_path__ + "static/media/image-13.81af05a2.webp";